// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"77":"1900a1f6","774":"7c3160eb"}[chunkId] + ".chunk.css";
};